<template>
  <header class="support-card-header">
    <span class="support-card-header__icon" :class="`is-${tone}`">
      <WorkbenchIcon :name="icon" :size="19" />
    </span>
    <span class="support-card-header__copy">
      <strong>{{ title }}</strong>
      <span>{{ description }}</span>
    </span>
  </header>
</template>

<script setup lang="ts">
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'

defineProps<{
  icon: string
  tone: 'wechat' | 'qq' | 'email' | 'x'
  title: string
  description: string
}>()
</script>

<style scoped lang="scss">
.support-card-header {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.support-card-header__icon {
  display: flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &.is-wechat {
    background: #e7f8ee;
    color: #07c160;
  }

  &.is-qq {
    background: #e6f6fe;
    color: #12b7f5;
  }

  &.is-email {
    background: #eaf3ff;
    color: #2f80ed;
  }

  &.is-x {
    background: #f2f4f7;
    color: #1f2329;
  }
}

.support-card-header__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;

  strong {
    color: #1f2329;
    font-size: 14.5px;
    font-weight: 700;
    line-height: 1.4;
  }

  > span {
    color: #646a73;
    font-size: 12px;
    line-height: 1.5;
  }
}
</style>
